var juuls    = juuls || {};
juuls.search = {
    settings: {
        minLength: 3
    },
    init: function () {
        if ( jQuery( '.js-relewise-search' ).length > 0 ) {
            jQuery.when.apply( jQuery, [
                e4.require.js( e4.settings.require.typeahead ),
                e4.require.js( e4.settings.require.jQueryValidate ),
                e4.require.js( e4.settings.require.handlebars )
            ] ).then( function () {
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-search-typeahead' );
                e4.handlebars.registerHelpers( 'compare' );
                juuls.search.bindEvents();
            } );
            
        }
        juuls.search.paging.init();
    },
    bindEvents: function () {
        var jRelewiseModal = jQuery( '.js-relewise-search-modal' );
        jQuery( '.js-relewise-mobile-input' ).on( 'input', e4.util.debounce( function ( event ) {
            if ( event.target.value.length >= juuls.search.settings.minLength ) {
                jQuery( '.js-e-search-form-inline-input' ).val( event.target.value ).trigger( 'input' );
            }
        }, e4.settings.debounceDelay.input ) );

        jQuery( window ).on( 'hashchange', function () {
            if ( e4.hash.get( 'search' ) !== undefined ) {
                jQuery( '.js-e-search-form-inline-input' ).val( e4.hash.get( 'search' ) ).trigger( 'input' ).trigger('focus');
            }
            
        } );
        
        
        jRelewiseModal.on( 'shown.bs.modal', function ( event ) {
            setTimeout( function () {
                jQuery( '.js-relewise-mobile-input' ).focus();
            }, 100 );
        } );
        jQuery( '.js-e-search-form-inline-input' ).on( 'input', function ( event ) {
            var jModalData = jRelewiseModal.data( 'bs.modal' );
            if ( event.target.value.length < juuls.search.settings.minLength && jModalData !== undefined && jModalData._isShown === true ) {
                juuls.search.toggleResults( false );
            }
        } ).on( 'focus', function ( event ) {
            if ( event.target.value.length >= juuls.search.settings.minLength ) {
                juuls.search.toggleResults( true );
            }
        } ).typeahead( {
            hint: true,
            highlight: true,
            minLength: juuls.search.settings.minLength,
            classNames: {
                wrapper: 'w-100 position-static d-flex',
                menu: 'dropdown-menu juuls-typeahead-menu',
                suggestion: 'dropdown-item',
                open: 'open',
                cursor: 'active',
                highlight: 'active'
            }
        }, {
            name: 'espresso',
            limit: 8,
            async: true,
            source: e4.util.debounce( function ( query, syncResults, asyncResults ) {
                jQuery( '.js-relewise-search-spinner' ).removeClass( 'd-none' );
                juuls.search.getRelewiseResponse( query, function ( data ) {
                    var jSearchInput = jQuery( '.js-e-search-form-inline-input' );
                    jQuery( '.js-relewise-autocomplete-content' )
                            .html( e4.handlebars.tmpl.searchTypeahead( data ) )
                            .find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                        if ( domForm ) {
                            e4.product.validateForm( domForm );
                        }
                    } );
                    e4.gtm.search(null, {
                        query: query,
                        resultCount: data.products.length
                    });
                    jSearchInput.trigger( 'focus' );
                    juuls.search.toggleResults( true );
                    jQuery( '.js-relewise-search-spinner' ).addClass( 'd-none' );
                    jQuery( '.js-search-result-loading-overlay' ).removeClass( 'is-loading' );
                } );
            }, e4.settings.debounceDelay.input )
        } ).on( 'typeahead:autocomplete typeahead:select', function ( event, product ) {
            if ( product !== null ) {
                jQuery( this ).typeahead( 'close' );
            }
        } ).prop('disabled', false);
        jRelewiseModal.on( 'show.bs.modal', function () {
            juuls.search.setPosition();
        } ).on( 'hidden.bs.modal', function () {
            jQuery( '.js-e-header' ).css( 'z-index', '' );
        } );
        jQuery( window ).on( 'resize', function () {
            var jModalData = jQuery( '.js-relewise-search-modal' ).data( 'bs.modal' );
            if ( jModalData !== undefined && jModalData._isShown === true ) {
                juuls.search.setPosition();
            }
        } );
        
    },
    getRelewiseResponse: function ( query, asyncResults ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        query = jQuery.trim( query );
        if ( query !== '' ) {
            this.jqXHR = jQuery.ajax( {
                method: 'GET',
                beforeSend: function () {
                    jQuery( '.js-search-result-loading-overlay' ).addClass( 'is-loading' );
                },
                url: e4.settings.relewise.search.url + encodeURIComponent( jQuery.trim( query ) ),
                dataType: 'json'
            } );
            this.jqXHR.done( function ( data ) {
                asyncResults( data );
            } );
        }
    },
    toggleResults: function ( boolShow ) {
        if ( boolShow ) {
            jQuery( '.js-relewise-autocomplete-content' ).removeClass( 'd-none' );
            jQuery( '.js-relewise-search-modal' ).modal( 'show' );
        }
        else {
            jQuery( '.js-relewise-autocomplete-content' ).addClass( 'd-none' );
            jQuery( '.js-relewise-search-modal' ).modal( 'hide' );
        }
    },
    setPosition: function () {
        var jHeader = jQuery( '.js-e-header' );
        jHeader.css( 'z-index', 1041 );
        var intHeaderHeight           = jHeader.height(),
            arrHeaderTranslatedValues = jHeader.css( 'transform' ).replace( /[^0-9\-.,]/g, '' ).split( ',' ),
            intHeaderTranslatedYValue = parseInt( arrHeaderTranslatedValues[ 13 ] || arrHeaderTranslatedValues[ 5 ] );
        jQuery( '.js-relewise-search-modal' ).css( 'top', intHeaderHeight - ( Math.abs( intHeaderTranslatedYValue ) ) );
    },
    paging: {
        jProductList: jQuery( '.js-relewise-productlist' ),
        page: 1,
        init: function () {
            if ( juuls.search.paging.jProductList.length === 1 ) {
                juuls.search.paging.bindEvents();
                juuls.search.paging.bindObserver();
                if ( history.state !== null && history.state.page !== undefined ) {
                    juuls.search.paging.page = history.state.page;
                }
            }
        },
        bindEvents: function () {
            juuls.search.paging.jProductList.on( 'click', '.js-e-productlist-item a[href]', function ( event ) {
                event.preventDefault();
                var domElm      = event.currentTarget,
                    initialTake = parseInt( jQuery( domElm ).closest( '.js-relewise-lazyloaded-item' ).data( 'initialTake' ) );
                history.replaceState( {
                    take: initialTake,
                    page: juuls.search.paging.page,
                    query: juuls.search.paging.jProductList.data( 'relewiseQuery' )
                }, null, location.pathname + ( `?take=${initialTake}&q=${juuls.search.paging.jProductList.data( 'relewiseQuery' )}` ) );
                location.href = domElm.href;
            } );
           
        },
        bindObserver: function () {
            var target = juuls.search.paging.jProductList.find( '.js-relewise-lazyload-trigger' ).toArray();
            e4.util.observer.bind( target, function ( objEntry, objObserver ) {
                if ( objEntry.isIntersecting === true ) {
                    objObserver.unobserve( objEntry.target );
                    juuls.search.paging.fetch();
                }
            }, e4.settings.ecom.lazyload.observerOptions );
        },
        fetch: function () {
            var strQuery = juuls.search.paging.jProductList.data( 'relewiseQuery' ),
                intTake  = parseInt( juuls.search.paging.jProductList.data( 'relewiseTake' ) ),
                intSkip  = parseInt( juuls.search.paging.jProductList.data( 'relewiseSkip' ) ),
                intHits  = parseInt( juuls.search.paging.jProductList.data( 'relewiseHits' ) );
            if ( intHits > 0 ) {
                intSkip = intSkip + intTake;
                intHits = intHits - intTake;
                juuls.search.paging.jProductList.data( 'relewiseSkip', intSkip );
                juuls.search.paging.jProductList.data( 'relewiseHits', intHits );
                jQuery.ajax( {
                    url: '/system/data/relewise-json',
                    beforeSend: function () {
                        jQuery( '.js-e-productlist-lazy-loading-block' ).removeClass( 'd-none' );
                    },
                    data: {
                        q: strQuery,
                        take: intTake,
                        skip: intSkip
                    }
                } ).done( function ( json ) {
                    jQuery( '.js-e-productlist-lazy-loading-block' ).addClass( 'd-none' );
                    juuls.search.paging.appendAndWatch( json.products, intSkip );
                } );
            }
        },
        appendAndWatch: function ( arrProducts ) {
            juuls.search.paging.page++;
            arrProducts.forEach( function ( objProduct ) {
                var item = `<div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 d-flex view-mode js-relewise-lazyloaded-item" data-initial-take="${( 24 * juuls.search.paging.page )}">${objProduct.listItemHtml}</div>`;
                jQuery( '#js-e-productlist-products' ).append( item );
            } );
            juuls.search.paging.bindObserver();
        }
    }
}